import { Button, ButtonProps } from "@chakra-ui/react";
import React, { memo } from "react";
import { useDelay } from "~/hooks";
import { colors } from "~/utils/theme";

interface Props extends ButtonProps {
  title?: string;
}

export const UiButton = memo(
  React.forwardRef<HTMLButtonElement, ButtonProps>(({ title, children, onClick, ...rest }: Props, ref) => {
    const bntTitle = title || children;
    const { startDelay, isDelaying } = useDelay(500);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (onClick && !isDelaying) {
        onClick(e);
        startDelay();
      }
    };

    return (
      <Button ref={ref} onClick={handleClick} {...rest}>
        {bntTitle}
      </Button>
    );
  })
);

export function UiBlackButton({ bg = "black", color = "white", ...rest }: ButtonProps) {
  return <UiButton color={color} variant="solid" _hover={{ color: "white", bg: colors.baliHai }} bg={bg} {...rest} />;
}

export function UiPrimaryButton({ bg = "navy", ...rest }: ButtonProps) {
  return (
    <UiButton
      variant="solid"
      color="white"
      _hover={{ color: "white", bg }}
      _disabled={{ bg: "neutral.gray200", color: "neutral.gray400" }}
      bg={bg}
      {...rest}
    />
  );
}
